"use strict";

import gsap from "gsap";

const aboutEnterAnimation = (container) => {
	const image = container.querySelector(".about__image");
	const content = container.querySelectorAll(".about__content > *");

	const tl = gsap.timeline();

	tl.to(image, { y: 0, duration: 1, ease: "power4.inOut" })
		.to(image, { opacity: 1, ease: "none", duration: 0.4 }, "-=0.6")
		.to(content, { y: 0, duration: 1, ease: "power4.inOut", stagger: 0.1 }, "-=1.2")
		.to(content, { opacity: 1, duration: 0.4, ease: "none", stagger: 0.1 }, "<0.3");

	return tl;
};

export default aboutEnterAnimation;
